import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateContainer, UpdateContainer} from "../../types/api/guide/container.types";

const pagedQuery = (page: number, pageSize: number, name?: string) => {
    const params: Record<string, string | number> = { page, pageSize };
    if (name != null && name.trim() !== "") params.name = name.trim();
    return { params };
};

export const containerService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.container.getAll),

    getPaged: (page: number, pageSize: number, name?: string) =>
        apiCall.get(apiUrls.guide.container.getPaged, pagedQuery(page, pageSize, name)),

    create: (container: CreateContainer) =>
        apiCall.post(apiUrls.guide.container.create, container),

    update: (id: string, container: UpdateContainer) =>
        apiCall.put(apiUrls.guide.container.update(id), container),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.container.delete(id))
}